/**
 * ErrorListItemDetails  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IErrorListItemDetailsProps {
	details: string[];
}

export const ErrorListItemDetails = React.memo<IErrorListItemDetailsProps>(({ details }) => {
	const baseClass = BEM("edt-error-list", "item-details");

	return (
		<ul className={baseClass.toClassName()}>
			{details.map((detailItem, i) => (
				<li key={i} className={baseClass.element("item-details-el").toClassName()}>
					{detailItem}
				</li>
			))}
		</ul>
	);
});

ErrorListItemDetails.displayName = "ErrorListItemDetails";
